module.exports = __webpack_public_path__ + "img/formIcon.8b471e94.svg";